export default __webpack_public_path__ + "media/images/grey_arrow-7210b5a9699c8538f67f9cbfd9ac38de.png";